<input
  class="select-option form-control"
  [(ngModel)]="itemDescricao"
  (ngModelChange)="onChangeItemDescricao($event)"
  [ngClass]="{'focus':isShowItems, 'no-cursor': readOnly}"
  [readOnly]="readOnly"
  placeholder="Digite ou selecione o item"
  type="text"
  (click)="hideItems()">
  <span class="chevron fa fa-chevron-down"
    *ngIf="!readOnly"
    aria-hidden="true"
    (click)="showHideItems()">
  </span>

<ul
  class="lista-items"
  *ngIf="isShowItems">
  <li
    class="item-custom"
    *ngFor="let item of itemsSelecionar">
    <a (click)="selectItem(item)">{{item.descricao}}</a>
  </li>
</ul>
